// extracted by mini-css-extract-plugin
export default {"beta":"Beta_beta__MKTAJ","container":"Beta_container__gvRaa","typedOut":"Beta_typedOut__YfDAu","typing":"Beta_typing__cXydZ"};